import {NavFactory} from './nav.factory';
import {NavItemCodes} from '../../enums/nav-item-codes.enum';
import {PermissionArea} from '../../enums/permission-area.enum';
import {IconCode} from '../../enums/icon-code.enum';

export class NavConfigFactory extends NavFactory {
    protected static basePaths = {
        config: '/admin/config',
        coAcquisition: '/admin/config/co-acquisition',
        transcoder: '/admin/config/transcoder'
    };
    protected static items = [
        {
            code: NavItemCodes.CONFIGURATION,
            icon: IconCode.CONFIG,
            label: 'NAV.CONFIG.LABEL',
            description: 'NAV.CONFIG.DESC',
            path: NavConfigFactory.basePaths.config,
            permissionArea: PermissionArea.CONFIGURATION,
            cy: 'config'
        },
        {
            code: NavItemCodes.TARIFF_ELEMENTS,
            icon: IconCode.TARIFF_ELEMENTS,
            label: 'NAV.TARIFF_ELEMENTS.LABEL',
            description: 'NAV.TARIFF_ELEMENTS.DESC',
            path: `${NavConfigFactory.basePaths.config}/tariff-elements`,
        },
        {
            code: NavItemCodes.BRANDS,
            icon: IconCode.BRANDS,
            label: 'NAV.BRANDS.LABEL',
            description: 'NAV.BRANDS.DESC',
            path: `${NavConfigFactory.basePaths.config}/brands`,
            permissionArea: PermissionArea.BRANDS_CONFIGURATION
        },
        {
            code: NavItemCodes.BRANDS_DELETE,
            icon: IconCode.BRANDS_DELETE,
            label: 'BRANDS.DELETE',
            description: 'BRANDS.DELETE',
        },
        {
            code: NavItemCodes.CO_ACQUISITION_CONFIGURATION,
            icon: IconCode.CO_ACQUISITION_CONFIGURATION,
            label: 'NAV.COACQUISITION.LABEL',
            description: 'NAV.COACQUISITION.DESC',
            path: `${NavConfigFactory.basePaths.config}/co-acquisition`,
            permissionArea: PermissionArea.CO_ACQUISITION_CONFIGURATION
        },
        {
            code: NavItemCodes.CO_ACQUISITION_ADD,
            icon: IconCode.CO_ACQUISITION_ADD,
            label: 'COACQUISITION.ADD',
            description: 'COACQUISITION.ADD',
            path: [`${NavConfigFactory.basePaths.coAcquisition}/add`],
        },
        {

            code: NavItemCodes.CO_ACQUISITION_EDIT,
            icon: IconCode.CO_ACQUISITION_EDIT,
            label: 'COACQUISITION.EDIT',
            description: 'COACQUISITION.EDIT',
            path: (coAcquisitionId) => [`${NavConfigFactory.basePaths.coAcquisition}`, coAcquisitionId]
        },
        {
            code: NavItemCodes.CO_ACQUISITION_DELETE,
            icon: IconCode.CO_ACQUISITION_DELETE,
            label: 'COACQUISITION.DELETE',
            description: 'COACQUISITION.DELETE',
        },
        {
            code: NavItemCodes.TRANSCODER_CONFIGURATION,
            icon: IconCode.TRANSCODER_CONFIGURATION,
            label: 'NAV.TRANSCODER.LABEL',
            description: 'NAV.TRANSCODER.DESC',
            path: NavConfigFactory.basePaths.transcoder,
            permissionArea: PermissionArea.TRANSCODER_CONFIGURATION,
            cy: 'transcoder'
        },
        {
            code: NavItemCodes.TRANSCODER_ADD,
            icon: IconCode.TRANSCODER_ADD,
            label: 'TRANSCODER.ADD',
            description: 'TRANSCODER.ADD',
            path: [`${NavConfigFactory.basePaths.transcoder}/add`],
            cy: 'transcoder-add'
        },
        {
            code: NavItemCodes.TRANSCODER_EDIT,
            icon: IconCode.TRANSCODER_EDIT,
            label: 'TRANSCODER.EDIT',
            description: 'TRANSCODER.EDIT',
            path: (transcoderId) => [NavConfigFactory.basePaths.transcoder, transcoderId],
            cy: 'transcoder-edit'
        },
        {
            code: NavItemCodes.TRANSCODER_DELETE,
            icon: IconCode.TRANSCODER_DELETE,
            label: 'TRANSCODER.DELETE',
            description: 'TRANSCODER.DELETE',
            path: (transcoderId) => [NavConfigFactory.basePaths.transcoder, transcoderId],
            cy: 'transcoder-delete'
        },
        {
            code: NavItemCodes.TRANSCODER_FORM_ADD,
            icon: IconCode.TRANSCODER_FORM_ADD,
            label: 'TRANSCODER.FORM.ADD',
            description: 'TRANSCODER.FORM.ADD',
            path: [`${NavConfigFactory.basePaths.transcoder}/add`],
        },
        {
            code: NavItemCodes.TRANSCODER_FORM_EDIT,
            icon: IconCode.TRANSCODER_FORM_EDIT,
            label: 'TRANSCODER.FORM.EDIT',
            description: 'TRANSCODER.FORM.EDIT',
            path: (transcoderId) => [NavConfigFactory.basePaths.transcoder, transcoderId]
        },
    ];
}
